export function isAccessDenied(error: unknown): boolean {
  const code = (error as { code?: string } | null)?.code;
  return (
    code === 'permission-denied' ||
    code === 'functions/permission-denied' ||
    code === 'not-found' ||
    code === 'functions/not-found'
  );
}
